import styled from "styled-components";
import { TileButton } from "@origin-digital/ods-tile-button";

export const StyledTileButton = styled(TileButton)(() => ({
  "&&": {
    padding: "11px 17px",
  },
}));

export const StyledTileButtonWithImage = styled(TileButton)(() => ({
  "&&": {
    lineHeight: 0,
    height: "151px",
    "& div[data-id='tile-input']": {
      paddingBottom: "33px",
    },
    "& div[data-id='tile-child']": {
      backgroundColor: "#F1F1F1",
    },
    "& div[id='not-sure']": {
      justifyContent: "center",
      display: "flex",
    },
  },
}));
